import { Component, Vue } from 'vue-property-decorator'
import Event from '@/components/shared/event/Event.vue'

@Component({
  components: { Event }
})
export default class AddEvent extends Vue {
}
